import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Button from "../Button";
import { RxCross2 } from "react-icons/rx";
import { AiFillAlert } from "react-icons/ai";


const dummyContent = {
    details: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    userName: "Micheal Coal",
    phoneNo: '123 123 123'
}

export default function AlertCard({ content = dummyContent, onCancel, onSuccess }) {
    return (
        <div className="flex items-center justify-center min-h-screen bg-pink-200">
            <div className="relative flex w-[520px] items-center justify-center md:justify-start md:items-stretch">
                <div className="w-[240px] h-[240px] hidden md:block relative border-[29px] border-[#E84142] rounded-full"></div>
                <div className="w-4/5 md:w-[480px] md:h-[200px] bg-white md:absolute bottom-4 top-5 md:right-[1.1rem] z-40 rounded-lg md:rounded-custom-shape flex flex-col justify-center md:justify-start md:flex-row items-center gap-1 px-1 shadow-custom-soft">
                    {/* gif circle */}
                    <div className="w-[170px] h-[170px] bg-[#F7F7F7] rounded-full m-[1rem] flex items-center justify-center">
                        <div className="flex h-[120px] w-[120px] items-center justify-center rounded-full bg-[#FFE9EA]">
                            <AiFillAlert size={68} color="#E54041" />
                        </div>
                    </div>
                    {/* content div */}
                    <div className="flex flex-col justify-center items-center gap-3 h-full md:items-start py-4 px-1">
                        <h3 className="font-bold tracking-wider text-lg">Alert!</h3>
                        <div className="flex gap-2">
                            {
                                content?.image ?
                                    <Avatar src={''} /> :
                                    <Avatar icon={<UserOutlined />} />
                            }
                            <div className="flex flex-col">
                                <p className="font-semibold text-[14px]">{content?.title?.length > 20 ? content?.title?.slice(0, 21) + '...' : content?.title}</p>
                                <p className="text-[#5B6982] font-medium text-[12px]">{content?.phoneNo}</p>
                            </div>
                        </div>
                        <p className="md:w-[200px] text-xs text-center md:text-left">{content?.body?.length > 60 ? content?.body?.slice(0, 61) + '...' : content?.body}</p>
                        {/* action btns */}
                        <div className="flex gap-2">
                            <Button.Basic
                                onClick={onCancel}
                                htmlType="submit"
                                className="text-red-500 rounded-2xl font-bold px-4 w-[80px] border border-[#E54041]"
                                style={{ backgroundColor: '#FFE9EA' }}
                                text={"No"}
                                type={"submit"}
                            />
                            <Button.Basic
                                onClick={onSuccess}
                                htmlType="submit"
                                className="text-gray-200 rounded-2xl font-bold w-[80px]"
                                style={{ backgroundColor: '#00E32B' }}
                                text={"Yes"}
                                type={"submit"}
                            />
                        </div>
                    </div>
                    {/* cross sign */}
                    <div className="absolute top-3 bottom-3 right-3 hidden md:block">
                        <RxCross2 size={20} className="cursor-pointer" onClick={onCancel} />
                    </div>
                </div>
            </div>
        </div>
    );
}
